export { FeaturedTestimonial } from './FeaturedTestimonial';
